import { useEffect, useState } from 'react';
import taskService from '../../../services/TaskService';

export default function useFetchDependencyOptions() {
  const [dependencyOptions, setDependencyOptions] = useState([]);

  useEffect(() => {
    const loadDependencyOptions = async () => {
      try {
        const response = await taskService.getDependencyOptions();
        setDependencyOptions(
          (response?.data?.data || []).map((task) => ({
            value: task._id || task.id,
            label: task.title || `Task ${String(task._id || task.id).slice(-8)}`,
            dependencyIds: (task.dependencies || []).map((dependency) => dependency?._id || dependency)
          }))
        );
      } catch (error) {
        // eslint-disable-next-line no-console, no-undef
        console.error('Could not fetch task dependencies:', error);
      }
    };

    loadDependencyOptions();
  }, []);

  return dependencyOptions;
}
